// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./libs/kendoUI/style/kendo.common.min.css
// module id = 745
// module chunks = 1